import { ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  as?: 'div' | 'section' | 'article' | 'main' | 'aside';
}

const sizeClasses = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-8xl',
  '2xl': 'max-w-9xl',
  full: 'max-w-full',
};

export default function Container({
  children,
  className,
  size = '2xl',
  as: Component = 'div',
}: ContainerProps) {
  return (
    <Component className={cn('mx-auto px-4 sm:px-6 lg:px-8', sizeClasses[size], className)}>
      {children}
    </Component>
  );
}
